<template>
    <v-fade-transition>
        <v-overlay v-show="loading" absolute>
            <v-progress-circular indeterminate size="200" width="10" />
        </v-overlay>
    </v-fade-transition>
</template>

<script>
export default {
    props: {
        loading: { type: Boolean, default: false },
    },
};
</script>

<style></style>
